import { X } from 'lucide-react';
import { cn } from './utils';

/**
 * Individually-removable active-filter chip (plans/filter-standardization-
 * spec.md §3). `label`/`value` render as `{label}: {value}` — callers are
 * responsible for resolving select-backed filters to their display value
 * (e.g. a manufacturer name, not a raw query param), never a raw id.
 *
 * The visible chip stays compact; the remove button's hit area is expanded
 * to the 44×44 touch floor via `.tap-target-44` (a transparent
 * pseudo-element) without growing the chip itself.
 */
export function FilterChip({
  label,
  value,
  onRemove,
  className,
}: {
  label: string;
  value: string;
  onRemove: () => void;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-border bg-muted px-2.5 py-1 text-xs text-foreground',
        className,
      )}
    >
      {label}: {value}
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${label} filter`}
        className="tap-target-44 ml-0.5 text-muted-foreground hover:text-foreground"
      >
        <X className="size-3" />
      </button>
    </span>
  );
}
